import { useState } from "react";

import { Modal } from "@/modules/common/components";
import EmailStep from "./EmailStep";
import CodeStep from "./CodeStep";
import NewPasswordStep from "../NewPasswordStep";

interface ForgotPasswordModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPasswordReset: (email: string) => void;
}

const STEP_CONTENT = {
  1: { title: "Esqueci minha senha", description: "Informe o e-mail da sua conta para receber um código de verificação." },
  2: { title: "Verifique seu e-mail", description: "Digite o código de 6 dígitos que enviamos para o e-mail informado." },
  3: { title: "Nova senha", description: "Crie uma nova senha para acessar sua conta." },
} as const;

const ForgotPasswordModal = ({ open, onOpenChange, onPasswordReset }: ForgotPasswordModalProps) => {
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setStep(1);
      setEmail("");
      setCode("");
    }
    onOpenChange(isOpen);
  };

  const handlePasswordResetSuccess = (resetEmail: string) => {
    handleOpenChange(false);
    onPasswordReset(resetEmail);
  };

  return (
    <Modal open={open} onOpenChange={handleOpenChange} title={STEP_CONTENT[step].title} description={STEP_CONTENT[step].description}>
      {step === 1 && (
        <EmailStep
          onClose={() => handleOpenChange(false)}
          onSent={(sentEmail) => {
            setEmail(sentEmail);
            setStep(2);
          }}
        />
      )}
      {step === 2 && (
        <CodeStep
          email={email}
          onBack={() => setStep(1)}
          onVerified={(verifiedCode) => {
            setCode(verifiedCode);
            setStep(3);
          }}
        />
      )}
      {step === 3 && <NewPasswordStep email={email} code={code} onSuccess={handlePasswordResetSuccess} />}
    </Modal>
  );
};

export default ForgotPasswordModal;
